module.exports = __webpack_public_path__ + "img/shop.299b5c59.png";